module.exports = __webpack_public_path__ + "img/bg.456bdfe8.jpg";